// frontend/src/pages/Admin/AdminDashboard.jsx (исправленный)
import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, Link } from 'react-router-dom';
import './AdminDashboard.css';
import { authService } from '../../services/authService';
import NewsManagement from './NewsManagement';
import ActivitiesManagement from './ActivitiesManagement';
import ContactsManagement from './ContactsManagement';
import AboutManagement from './AboutManagement';
import UsersManagement from './UsersManagement';
import logo from '../../assets/images/logo/logo.svg';

const AdminDashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    if (!currentUser) {
      navigate('/admin/login');
      return;
    }
    setUser(currentUser);
    setLoading(false);
  }, [navigate]);

  const handleLogout = () => {
    authService.logout();
    navigate('/admin/login');
  };

  if (loading) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-dashboard">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img src={logo} alt="Family Park" className="admin-logo" />
          <div className="admin-user-info">
            <span className="admin-user-name">{user.username}</span>
            <span className="admin-user-role">
              {user.role === 'admin' ? 'Администратор' : 'Редактор'}
            </span>
          </div>
        </div>
        
        <nav className="admin-nav">
          <Link to="/admin/dashboard/news" className="admin-nav-link">
            Новости
          </Link>
          <Link to="/admin/dashboard/activities" className="admin-nav-link">
            Активности
          </Link>
          <Link to="/admin/dashboard/contacts" className="admin-nav-link">
            Контакты
          </Link>
          <Link to="/admin/dashboard/about" className="admin-nav-link">
            О парке
          </Link>
          {user.role === 'admin' && (
            <Link to="/admin/dashboard/users" className="admin-nav-link">
              Пользователи
            </Link>
          )}
        </nav>
        
        <button onClick={handleLogout} className="admin-logout-button">
          Выйти
        </button>
      </aside>
      
      <main className="admin-main">
        <Routes>
          <Route path="news" element={<NewsManagement />} />
          <Route path="activities" element={<ActivitiesManagement />} />
          <Route path="contacts" element={<ContactsManagement />} />
          <Route path="about" element={<AboutManagement />} />
          {user.role === 'admin' && (
            <Route path="users" element={<UsersManagement />} />
          )}
          <Route path="/" element={
            <div className="admin-welcome">
              <h2>Добро пожаловать в админ-панель</h2>
              <p>Выберите раздел для управления</p>
            </div>
          } />
        </Routes>
      </main>
    </div>
  );
};

export default AdminDashboard;